import React, { useState, useEffect } from 'react'
import './index.css'
import COLORS from '../../colors'
import { Button } from '@material-ui/core'
import { ReactComponent as Alert } from '../../assets/alert.svg'
import { ReactComponent as Close } from '../../assets/close_gray.svg'
import { isMobile } from 'react-device-detect'

const ModalDeleteAlert = ({ popup, onClose, onDelete, pageNumber={pageNumber} }) => {
		const [ width, setWidth ] = useState(window.innerWidth)
		const [ height, setHeight ] = useState(window.innerHeight)

		useEffect(()=>
		{
			function setInnerDimension()
			{
					setWidth(window.innerWidth)
					setHeight(window.innerHeight)	 	 
			}
			window.addEventListener('resize', setInnerDimension, false)
			return () => window.removeEventListener('resize', setInnerDimension, false)
		},[])

	if (!popup) return null
    return (
    			<div className="modal" >
					<div className="overlay-modal" />
					<div className="modal-body" style={{width:!isMobile?'25rem':'90%', height:!isMobile?(height>820?'21rem':'45%'):'50%'}}>
						<div className="modal-delete-alert">
							<div className="modal-delete-alert-title">Jeste li sigurni?</div>
							<Close className="btn-close-btn" onClick={() => onClose()}/>
						</div>
						<Alert />
						{pageNumber===8&&<div className="modal-delete-text">Sigurno želiš izbrisati označene artikle?</div>}
						{pageNumber===9&&<div className="modal-delete-text">Sigurno želiš izbrisati označene korisnike?</div>}
						<Button size="large" 
                 			variant="contained"
                 			style={{ width:'90%', 
                             	color:"#fff", 
                             	fontWeight: 'bold', 
                             	backgroundColor:COLORS.blue, 
                     		 	textTransform: 'none',
							 	margin:'1rem',
								"&:hover": {
									backgroundColor: COLORS.blue
							  	} 
                       			}} 
							onClick={() => onDelete()}
						>POTVRDI</Button>
						<Button size="large" 
                 			variant="contained"
                 			style={{ width:'90%', 
                             	color:"#000", 
                             	fontWeight: 'bold', 
                             	backgroundColor:'#fff',
								border: '2px solid #2F2F5B',
								marginBottom: '1rem',  
                     		 	textTransform: 'none',
								"&:hover": {
									backgroundColor: '#fff'
							  	} 
                       			}} 
							onClick={() => onClose()}
						>ODUSTANI</Button>	
					</div>
    			</div>
	)
}

export default ModalDeleteAlert
